<template>
  <div class="limit-input-box">
    <el-input
      v-bind="$attrs"
      v-on="$listeners"
      :style="styles"
      :size="size"
      @input="$emit('input', $event)"
      :value="value"
      class="limit-input"
      :maxlength="maxlength"
    >
      <slot name="prefix" slot="prefix"></slot>
      <slot name="suffix" slot="suffix"></slot>
      <slot name="prepend" slot="prepend"></slot>
      <slot name="append" slot="append"></slot>
      <slot></slot>
    </el-input>
    <span class="limit" v-if="showLimit">{{`${inputLent}/${maxlength}`}}</span>
  </div>
</template>

<script>
export default {
  name: 'LimitInput',
  props: {
    maxlength: Number,
    showLimit: {
      type: Boolean,
      default: false,
    },
    width: String,
    minWidth: String,
    maxWidth: String,
    size: String,
    value: [String, Number],
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  computed: {
    inputLent: (vm) => vm.value.length || 0,
    styles() {
      const { width, minWidth, maxWidth } = this;
      return { width, minWidth, maxWidth };
    },
  },
};
</script>

<style lang="scss" scoped>
.limit-input-box{
  position: relative;
  display: inline-block;
  .limit{
    color: #8D9299;
    font-size: 12px;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0,-50%);
    display: inline-block;
  }
}
</style>